import { supabase } from '../../lib/supabase';
import { netlifyFunctionsBase } from '../netlifyFunctionsBase';
import type { EstudioProveedorIa } from './types';

/** Local CRA has no functions. The live site already runs GPT Image 2.5. */
function estudioGenerarUrl(): string {
  if (typeof window !== 'undefined' && /^(localhost|127\.0\.0\.1)$/.test(window.location.hostname)) {
    return 'https://clientelo.com.co/.netlify/functions/estudio-generar-imagen';
  }
  return `${netlifyFunctionsBase()}/estudio-generar-imagen`;
}

export class EstudioIaError extends Error {
  code: string;
  usadas?: number;
  limite?: number;
  constructor(message: string, code: string, extra?: { usadas?: number; limite?: number }) {
    super(message);
    this.code = code;
    this.usadas = extra?.usadas;
    this.limite = extra?.limite;
  }
}

export async function generarImagenEstudio(opts: {
  empresaId: string;
  prompt: string;
  images: { mimeType: string; base64: string }[];
  provider?: EstudioProveedorIa;
  ownApiKey?: string;
}): Promise<{ file: File; usadas: number | null; limite: number | null; engine: string; cortesia: boolean }> {
  const { data: session } = await supabase.auth.getSession();
  const token = session.session?.access_token;
  if (!token) throw new EstudioIaError('Inicia sesión para usar la IA.', 'NO_SESSION');

  const res = await fetch(estudioGenerarUrl(), {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({
      empresaId: opts.empresaId,
      prompt: opts.prompt,
      images: opts.images,
      provider: opts.provider || 'cortesia',
      ownApiKey: opts.ownApiKey || undefined,
    }),
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    throw new EstudioIaError(
      data.error || 'No se pudo generar la imagen',
      data.code || 'ERROR',
      { usadas: data.usadas, limite: data.limite }
    );
  }
  const bytes = Uint8Array.from(atob(data.base64), (c) => c.charCodeAt(0));
  const mime = data.mimeType || 'image/png';
  const ext = mime.includes('jpeg') || mime.includes('jpg') ? 'jpg' : 'png';
  const file = new File([bytes], `ia-estudio-${Date.now()}.${ext}`, { type: mime });
  return {
    file,
    usadas: data.usadas ?? null,
    limite: data.limite ?? null,
    engine: data.engine || '',
    cortesia: Boolean(data.cortesia),
  };
}
